import {
    Typography
} from 'antd';
import {
    UpOutlined, DownOutlined
} from '@ant-design/icons';
import './Data.css';
import * as PropTypes from 'prop-types';

const ExpandableText = ({rows = 1, text}) => {
    return (
        <div className="expand-text-control">
            <Typography.Paragraph
                ellipsis={{
                    rows:rows,
                    expandable: 'collapsible',
                    symbol:((expanded) => {
                        return (
                            <div className="expand-text-icon">
                                {expanded ? <UpOutlined/> : <DownOutlined/>}
                            </div>
                        )
                    })
                }}>
                {text}
            </Typography.Paragraph>
        </div>)
}

ExpandableText.propTypes = {
    rows: PropTypes.number, 
    text: PropTypes.string.isRequired
  };

export default ExpandableText;